// Modules
import { useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"

// Context
import { useAuthContext } from "~context/authContext"

const usePublicPath = () => {
  const navigate = useNavigate()
  const location = useLocation()

  // Get from context
  const { loggedUser, isLoggedIn } = useAuthContext()
  const isUserLoggedIn = isLoggedIn()

  // Use Effect
  useEffect(() => {
    if (isUserLoggedIn) {
      const routeState = location.state as { redirect?: string } | null
      const redirect =
        !routeState || !routeState.redirect
          ? "/app"
          : routeState.redirect === "app"
          ? "/app"
          : `/app/${routeState.redirect}`

      navigate(redirect)
    }
  }, [loggedUser]) // eslint-disable-line react-hooks/exhaustive-deps

  return isUserLoggedIn
}

export default usePublicPath
